import TourPage from "@/components/TourPage";

export default function ExperienceNature19Day() {
  return (
    <TourPage
      tourId="uganda/experience-nature-19-day"
      title="19-Day Uganda Experience Nature"
      duration="19 Days / 18 Nights"
      price="Contact for price"
      image="/kabale.jpg"
      description="An extensive 19-day journey through Uganda's most spectacular natural wonders, combining wildlife viewing, primate encounters, and cultural experiences."
      itinerary={[
        {
          day: 1,
          title: "Arrival at Entebbe International Airport",
          description: "Welcome to Uganda, the Pearl of Africa.",
          activities: [
            "Meet and greet at the airport",
            "Transfer to your hotel for briefing and overnight stay"
          ],
          accommodation: "Hotel in Entebbe",
          meals: "Dinner"
        },
        {
          day: 2,
          title: "Drive to Jinja, Visit the Source of the Nile",
          description: "Discover the historic source of the Nile River and explore Jinja.",
          activities: [
            "Drive to Jinja and visit the source of the Nile",
            "Explore the town and its surroundings"
          ],
          accommodation: "Lodge in Jinja",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Transfer to Mbale, Visit Sipi Falls",
          description: "Experience the beautiful cascade of waterfalls on the slopes of Mount Elgon.",
          activities: [
            "Drive to Mbale and visit Sipi Falls",
            "Explore the surrounding area and the scenic views"
          ],
          accommodation: "Lodge in Sipi Falls area",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Transfer to Kidepo Valley National Park",
          description: "Journey to one of Africa's most spectacular yet least visited parks.",
          activities: [
            "Drive to Kidepo Valley National Park",
            "Check-in at your lodge and dinner"
          ],
          accommodation: "Lodge in Kidepo",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 5,
          title: "Game Drives in Kidepo Valley National Park",
          description: "Explore the incredible diversity of wildlife in this remote wilderness.",
          activities: [
            "Take a morning game drive and spot lions, cheetahs, and other wildlife",
            "Enjoy a relaxing evening at your lodge"
          ],
          accommodation: "Lodge in Kidepo",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 6,
          title: "Transfer to Murchison Falls National Park",
          description: "Travel to Uganda's largest and oldest conservation area.",
          activities: [
            "Drive to Murchison Falls National Park",
            "Check-in at your lodge and dinner"
          ],
          accommodation: "Lodge in Murchison Falls",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 7,
          title: "Game Drives and Boat Cruise in Murchison Falls National Park",
          description: "Experience the rich wildlife and powerful falls on the Victoria Nile.",
          activities: [
            "Take a morning game drive and spot wildlife",
            "Enjoy a boat cruise on the Nile and spot hippos and crocodiles"
          ],
          accommodation: "Lodge in Murchison Falls",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 8,
          title: "Game Drives and Visit to the Top of the Falls",
          description: "Get up close to the mighty Murchison Falls.",
          activities: [
            "Take a morning game drive and spot wildlife",
            "Visit the top of the falls and explore scenic views"
          ],
          accommodation: "Lodge in Murchison Falls",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 9,
          title: "Transfer to Kibale Forest National Park",
          description: "Travel to Uganda's primate capital with its impressive rainforest.",
          activities: [
            "Drive to Kibale Forest National Park",
            "Check-in at your lodge and dinner"
          ],
          accommodation: "Lodge in Kibale",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 10,
          title: "Chimpanzee Tracking in Kibale Forest National Park",
          description: "Come face to face with our closest relatives in their natural habitat.",
          activities: [
            "Go chimpanzee tracking in the morning",
            "Take a guided nature walk in the afternoon"
          ],
          accommodation: "Lodge in Kibale",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 11,
          title: "Transfer to Queen Elizabeth National Park",
          description: "Journey to Uganda's most popular wildlife reserve.",
          activities: [
            "Drive to Queen Elizabeth National Park",
            "Check-in at your lodge and dinner"
          ],
          accommodation: "Lodge in Queen Elizabeth",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 12,
          title: "Game Drive and Boat Cruise in Queen Elizabeth National Park",
          description: "Explore the diverse ecosystems and abundant wildlife.",
          activities: [
            "Take a morning game drive and spot wildlife",
            "Enjoy a boat cruise on the Kazinga Channel"
          ],
          accommodation: "Lodge in Queen Elizabeth",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 13,
          title: "Game Drive and Transfer to Ishasha Sector",
          description: "Search for the famous tree-climbing lions in the southern sector of the park.",
          activities: [
            "Take a morning game drive and spot wildlife",
            "Transfer to the Ishasha sector and a game drive"
          ],
          accommodation: "Lodge in Ishasha",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 14,
          title: "Transfer to Bwindi Impenetrable National Park",
          description: "Journey to the mountain gorilla sanctuary.",
          activities: [
            "Drive to Bwindi Impenetrable National Park",
            "Check in at your lodge and delight in dinner"
          ],
          accommodation: "Lodge in Bwindi",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 15,
          title: "Gorilla Trekking in Bwindi Impenetrable National Park",
          description: "The ultimate wildlife experience - coming face to face with endangered mountain gorillas.",
          activities: [
            "Go gorilla trekking in the morning",
            "Return to your lodge and dinner"
          ],
          accommodation: "Lodge in Bwindi",
          meals: "Breakfast, Packed Lunch, Dinner"
        },
        {
          day: 16,
          title: "Transfer to Lake Bunyonyi",
          description: "Travel to one of Africa's most beautiful lakes.",
          activities: [
            "Drive to Lake Bunyonyi and enjoy the scenic views",
            "Check-in at your lodge and dinner"
          ],
          accommodation: "Lodge at Lake Bunyonyi",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 17,
          title: "Transfer to Lake Mburo National Park",
          description: "Journey to Uganda's smallest savannah national park.",
          activities: [
            "Drive to Lake Mburo National Park",
            "Check-in at your lodge and dinner"
          ],
          accommodation: "Lodge in Lake Mburo",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 18,
          title: "Game Drive and Bush Walk in Lake Mburo National Park",
          description: "Experience this compact gem with unique wildlife viewing opportunities.",
          activities: [
            "Take a morning game drive and spot wildlife",
            "Enjoy a bush walk in the afternoon"
          ],
          accommodation: "Lodge in Lake Mburo",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 19,
          title: "Departure",
          description: "Final day in Uganda before your journey home.",
          activities: [
            "Drive back to Kampala and transfer to the airport for your departure flight"
          ],
          meals: "Breakfast"
        }
      ]}
      inclusions={[
        "All park entrance fees and permits",
        "All activities, including chimpanzee tracking, gorilla trekking, and boat cruises",
        "All meals (breakfast, lunch, and dinner)",
        "A professional driver guide",
        "All transportation and airport transfers in a 4x4 luxury vehicle",
        "Accommodation for all nights"
      ]}
      exclusions={[
        "International flights (from/to home)",
        "Personal items (souvenirs, travel insurance, visa fees, etc.)",
        "The government imposed an increase in taxes and/or park fees",
        "Coffee, soft drinks, snacks, and drinking water (on all days)",
        "Personal requirements apart from the included",
        "Tip"
      ]}
    />
  );
}
